import Vue from "vue";
import Router from "vue-router";
import BackHome from "@/views/BackHome/BackHome";
import { setupRouterGuard } from "./guads";

Vue.use(Router);
/** home **/
// /** Backhome **/
// const Backhome = resolve =>{
//   import ('@/views/Backhome/Backhome').then(module =>{
//     resolve(module);
//   })
// }
/** AgrProduct **/
const AgrProduct = resolve => {
  import("@/views/AgrProduct/AgrProduct").then(module => {
    resolve(module);
  });
};
/** ProductWiki **/
const ProductWiki = resolve => {
  import("@/views/ProductWiki/ProductWiki").then(module => {
    resolve(module);
  });
};
/** Agricultural **/
const Agricultural = () => import("@/views/Agricultural/Agricultural");

/** CliRegion **/
const CliRegion = resolve => {
  import("@/views/CliRegion/CliRegion").then(module => {
    resolve(module);
  });
};
/** AgrInfo **/
const AgrInfo = resolve => {
  import("@/views/AgrInfo/AgrInfo").then(module => {
    resolve(module);
  });
};
/** PolicyNewsList **/
const PolicyNewsList = resolve => {
  import("@/views/AgrInfo/PolicyNewsList").then(module => {
    resolve(module);
  });
};
/** policyNewsDetail **/
const policyNewsDetail = resolve => {
  import("@/views/AgrInfo/policyNewsDetail").then(module => {
    resolve(module);
  });
};
/** AlarmDetail **/
const AlarmDetail = resolve => {
  import("@/views/Alarm/AlarmDetail").then(module => {
    resolve(module);
  });
};
/** AlarmDetail **/
const AgroWeather = resolve => {
  import("@/views/AgroWeather/AgroWeather").then(module => {
    resolve(module);
  });
};
/** DowloadApp **/
const DownloadApp = resolve => {
  import("@/views/Download/DownloadApp").then(module => {
    resolve(module);
  });
};

const routes = [
  {
    path: "/",
    redirect: "/home",
    meta: {
      isHome: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/index.vue")
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/Home/index.vue"),
    meta: {
      isHome: true
    }
  },
  {
    path: "/DownloadApp",
    name: "DownloadApp",
    component: DownloadApp
  },
  {
    path: "/backhome",
    name: "backhome",
    component: () => import("@/layouts/index.vue"),
    children: [
      {
        path: "agrProduct",
        name: "agrProduct",
        component: AgrProduct
      },
      {
        path: "cliRegion",
        name: "cliRegion",
        component: CliRegion
      },
      {
        path: "agrInfo",
        name: "agrInfo",
        component: AgrInfo
      },
      {
        path: "agrInfo/newsList",
        name: "policyNewsList",
        component: PolicyNewsList
      },
      {
        path: "agrInfo/newsDetail",
        name: "policyNewsDetail",
        component: policyNewsDetail
      },
      {
        path: "productWiki",
        name: "productWiki",
        component: ProductWiki
      },
      {
        path: "AlarmDetail",
        name: "AlarmDetail",
        component: AlarmDetail
      },
      {
        path: "AgroWeather",
        name: "AgroWeather",
        component: AgroWeather
      },
      {
        path: "agricultural",
        name: "agricultural",
        component: Agricultural
      }
    ]
  }
];

const router = new Router({
  mode: "history",
  routes
});
// 路由重置，刷新效果
export const resetRouter = () => {
  location.reload();
};
setupRouterGuard(router);
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js